export const SEGMENTS_FINISH_SEGMENT_DELETION = 'SEGMENTS_FINISH_SEGMENT_DELETION';
